import * as React from 'react';
import { ChildComponentProps } from 'google-map-react';
import cn from 'classnames';

const styles = require('./MapAnnotation.scss');
const mapPin = require('../../assets/icons/locationpin.svg');

export interface MapAnnotationProps extends ChildComponentProps {
    focusedVenueKey: string | null;
    venueId: number;
}

const MapAnnotation = (props: MapAnnotationProps) => {
    const isFocused = props.focusedVenueKey === props.venueId.toString();
    const isUnfocused = !isFocused && props.focusedVenueKey !== null;

    return (
        <div data-annotation-id={props.venueId}>
            <div
                className={cn(
                    {
                        [styles.focused]: isFocused,
                        [styles.unfocused]: isUnfocused,
                    },
                    styles.markerContainer
                )}
            >
                <img src={mapPin} />
            </div>
        </div>
    );
};

export default MapAnnotation;
